import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { GlobalStyle } from 'styles/global';
import './asset/style.css';
import AppProvider from './hook';
import reportWebVitals from './reportWebVitals';
import Routes from './route/privateRoutes';
import { initSentry } from './service/sentry';

initSentry();

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p>Algo deu errado. Recarregue a página.</p>}
    >
      <AppProvider>
        <Routes />
        <GlobalStyle />
      </AppProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  // eslint-disable-next-line no-undef
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
